import { useQuery } from '@tanstack/react-query';

import { fetchSuggestedOffers } from '../api.ts';

import { RQ_SUGGESTED_OFFERS } from '@/modules/ReactQuery/cacheKeys.ts';

type Props = {
  enabled?: boolean;
  productId: string;
};
export function useSuggestedOffers({ enabled = false, productId }: Props) {
  return useQuery({
    queryKey: [RQ_SUGGESTED_OFFERS, productId],
    queryFn: async () => {
      const res = await fetchSuggestedOffers(productId);
      return res?.data;
    },
    enabled,
    retryOnMount: false,
    refetchOnWindowFocus: false,
  });
}
